import createIcon from '../../createIcon';

/**
 * @component @name RoundaboutRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuOTIgOEMxMy40NCA1LjE2IDEwLjk3IDMgOCAzQzQuNjkgMyAyIDUuNjkgMiA5QzIgMTEuOTcgNC4xNiAxNC40NCA3IDE0LjkyVjIxSDlWMTQuOTFDOSAxMy45MyA4LjI5IDEzLjExIDcuMzMgMTIuOTRDNS40NCAxMi42MyA0IDEwLjk4IDQgOUM0IDYuNzkgNS43OSA1IDggNUM5Ljk4IDUgMTEuNjMgNi40NCAxMS45NCA4LjMzQzEyLjExIDkuMjkgMTIuOTMgMTAgMTMuOTEgMTBIMTguMTdMMTYuNTggMTEuNTlMMTggMTNMMjIgOUwxOCA1TDE2LjU5IDYuNDFMMTguMTcgOEgxMy45MloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RoundaboutRight = createIcon('RoundaboutRight', [
  [
    'path',
    {
      d: 'M13.92 8C13.44 5.16 10.97 3 8 3C4.69 3 2 5.69 2 9C2 11.97 4.16 14.44 7 14.92V21H9V14.91C9 13.93 8.29 13.11 7.33 12.94C5.44 12.63 4 10.98 4 9C4 6.79 5.79 5 8 5C9.98 5 11.63 6.44 11.94 8.33C12.11 9.29 12.93 10 13.91 10H18.17L16.58 11.59L18 13L22 9L18 5L16.59 6.41L18.17 8H13.92Z',
      key: '1mtkke',
    },
  ],
]);

export default RoundaboutRight;
